const HeaderImage: React.FC = () => {

  return (
    <img
      className="hidden absolute mt-8 ltr:left-6 rtl:right-6 top-0 lg:block"
      src="/assets/o_series/logo_horizontal.svg"
      width="209"
      height="36"
    />
  )
}

export default HeaderImage
